import { Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import {
  TraderHeaderContainer,
  TraderHeaderSwitchContainer,
  TraderTextStyle
} from '../TraderDetails.style'
import { IOSSwitch } from '../../ClientMmDetails/ClientMmDetails.style'

const TraderHeader = ({ trader, handelChange, form }) => {
  return (
    <TraderHeaderContainer>
      <TraderTextStyle>{form?.trader_name}</TraderTextStyle>
      <TraderHeaderSwitchContainer>
        <IOSSwitch name="is_active" checked={form.is_active} onChange={handelChange} />
        <Typography>Active</Typography>
      </TraderHeaderSwitchContainer>
    </TraderHeaderContainer>
  )
}

export default TraderHeader

TraderHeader.propTypes = {
  trader: PropTypes.object,
  handelChange: PropTypes.func,
  form: PropTypes.object
}
